<ul class="sd-footnotes">
    @for (curFootnote of data().notes; track $index) {
        <li [innerHTML]="curFootnote"></li>
    }
</ul>